export default {
    global: {
        server:{
            login: '/login',
            logout: '/logout',
            validate: '/validate',
            serviceValidate: '/serviceValidate',
            ticket: 'ticket',
            responseType: "XML"
        }
    },
    prod: {
        url: "https://sso.ynov.com",
        service: "https://evenement.ynov-bordeaux.com/",
        redirect: "https://evenement.ynov-bordeaux.com/"
    },
    dev: {
        url: "https://sso.beta.ynov.com",
        service: "http://localhost:6075",
        redirect: 'http://localhost:6075'
    }
}



// WEBPACK FOOTER //
// ./src/config/sso.js